import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sa-status-tag',
  templateUrl: './status-tag.component.html',
  styleUrls: ['./status-tag.component.scss']
})
export class StatusTagComponent implements OnInit {

  @Input() status: 'draft' | 'published';

  constructor() { }

  ngOnInit(): void {
  }

}
